import { MicrophoneMediaStream } from 'common/Globals'
import { getCodecCapabilities } from 'common/RTCUtils'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setCodecCapabilities } from 'store/actions/userAgent'

/* Get browser supported codecs list */
export const useCodecCapabilities = () => {
    const dispatch = useDispatch()
    const mediaStream = MicrophoneMediaStream.current

    useEffect(() => {
        if (mediaStream instanceof MediaStream) {
            getCodecCapabilities(mediaStream).then((supportedCodecs) => {
                dispatch(setCodecCapabilities(supportedCodecs))
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mediaStream])
}
